import { debug } from '../util/log'
import { RepositoryFactory } from '../data/RepositoryFactory'
import { Events } from '../events'

const OHMRepository = RepositoryFactory.get('ohm')

export const editorModule = {
  namespaced: true,
  state: () => ({
    focused: false, // If true, hide sidebar and editor content
    tabPage: 'hints',
    dates: {},
    loadingDates: false,

    articleDataPromise: null,
  }),
  mutations: {
    setFocused(state, focused) {
      state.focused = focused
    },
    setTabPage(state, tabPage) {
      state.tabPage = tabPage
    },
    setLoadingDates(state, loading) {
      state.loadingDates = loading
    },
    setArticleDates(state, { id_link, dates }) {
      state.dates[id_link] = dates
    }
  },
  actions: {
    loadArticleData({ commit, state, dispatch, rootState }, article) {
      // TODO: no need to take article as parameter, just get it from article store
      debug('loadArticleData called in editor.js')
      if (!state.articleDataPromise) {
        state.articleDataPromise = Promise.all(
          [
            new Promise((resolve) => {
              if (!article) {
                return resolve()
              }

              if (rootState.site.data.ocl_version !== 4) {
                debug('Not PyOCL, not fetching hint impact')
                return resolve()
              }

              commit('hint/setImpactLoading', true, { root: true })
              debug('editor calling getHintImpacat')
              OHMRepository.getHintImpact(article.id_link)
              .then((response) => {
                if (response && response.data) {
                  if (response.data.hint_impact) {
                    commit('hint/setImpact', response.data.hint_impact, { root: true })
                  } else {
                    Events.$emit('addNotification', {
                      type: response.data.type || 'error',
                      subject: 'Failed to load hint impact',
                      msg: response.data.message,
                      timeout: 4
                    })
                  }
                }
              })
              .then(() => {
                commit('hint/setImpactLoading', false, { root: true })
                resolve()
              })
            }),
            new Promise((resolve) => {
              if (this.hints && state.tabPage === 'dates') {
                dispatch('loadArticleDates') // TODO: do we need to call this here?
                debug('call loadArticleDates() from editor store')
              }
              resolve()
            })
          ]
        )
        .finally(() => {
          state.articleDataPromise = null
        })
      }
      return state.articleDataPromise
    },
    loadArticleDates({ commit, state, rootState }) {
      if (!rootState.article.selected || rootState.article.selected.id_link in state.dates) {
        debug("loadArticleDates canceled.")
        return Promise.resolve()
      }
      commit('setLoadingDates', true)
      return OHMRepository.getArticleDates(rootState.article.selected.id_link)
      .then((response) => {
        if (response && response.data.dates && response.data.id_link) {
          // TODO: do we need to use $set here to force reactivity or does vuex take care of it? normally in components $set is required

          commit('setArticleDates', { id_link: response.data.id_link, dates: response.data.dates})
          // state.dates[response.data.id_link] = response.data.dates
          // this.$set(state.dates, response.data.id_link, response.data.dates)
        } else {
          // TODO: error
        }
      })
      .catch(() => {
        //console.error(error)
      })
      .then(() => {
        commit('setLoadingDates', false)
      })
    }
  }
}
